module.exports = __webpack_public_path__ + "img/top_image2.ad9306e8.png";